import React, { Component } from "react"
import { Group, Col } from "./"

class Section extends Component {
  static defaultProps = {
    hasDivider: true,
    dark: false
  }

  renderDivider() {
    if (this.props.hasDivider) {
      return (
        <div className="wrap">
          <div className="divider" />
        </div>
      )
    }
    return null
  }

  render() {
    return (
      <section className={this.props.dark ? 'dark' : 'light'}>
        <div className="wrap">{this.props.children}</div>
        {this.renderDivider()}
      </section>
    )
  }
}

export { Section }
